// extracted by mini-css-extract-plugin
module.exports = {"jobWidth":"196px","jobHeight":"80px","wrapper":"JobAnimationWrapper__wrapper--oo","startAnimation":"JobAnimationWrapper__startAnimation--Kq"};